module.exports = __webpack_public_path__ + "img/transcosmos-logo-1.36a8eac8.svg";